export const createDtoBusquedaEstudiosDisponibles = ({
  circuito,
  familiar,
  fechaDesde,
  gruposMedico,
  particular,
  videoAtencion,
  conContraste,
  idGrupoMedico,
  OsAlternativa,
  amamantando,
  contrasteReciente,
  diabeticoHipertenso,
  embarazada,
  insRenal,
  marcapasos,
  peso,
  minutosGrupo,
  bioseguridadDTO
}) => {
  let dtoEstudioTurnos = {
    circuito: circuito,
    amamantando: amamantando,
    conContraste: conContraste,
    contrasteReciente: contrasteReciente,
    diabeticoHipertenso: diabeticoHipertenso,
    embarazada: embarazada,
    fechaDesde: fechaDesde,
    GruposMedico: gruposMedico,
    idGrupoMedico: idGrupoMedico,
    idObraSocial: familiar?.obraSocial,
    idPlan: familiar?.idPlan,
    insRenal: insRenal,
    marcapasos: marcapasos,
    operador: "",
    pag: 1200, //hardcodeado en angular
    particular: particular,
    peso: peso ? peso : 0,
    rec: 0, //harcodeado en angularionic
    videoAtencion: videoAtencion,
    OsAlternativa: OsAlternativa,
    sectorTurno: process.env.REACT_APP_SECTOR_TURNO,
    minutosGrupo: minutosGrupo,
    bioseguridadDTO: bioseguridadDTO,
  };
  return dtoEstudioTurnos;
};

export const createDtoCalculaMinutos = ({
  gruposMedico,
  familiar,
  conContraste,
}) => {
  // Cada item lleva su propio flag particular. El backend lo respeta:
  // - particular=true en el item → fuerza particular para ese estudio (caso B y C).
  // - particular=false en el item + IdObraSocial+IdPlan reales → chequea contratos (caso A).
  // - particular=false en el item sin OS/plan → backend deja particular=false.
  const nuevoGrupoMedico = gruposMedico.map((item) => ({
    id: item.Id,
    descripcion: item.Descripcion,
    particular: !!item.Particular,
  }));

  return {
    ConContraste: conContraste,
    GruposMedico: nuevoGrupoMedico,
    IdObraSocial: familiar?.obraSocial ?? "",
    IdPlan: familiar?.idPlan ?? 0,
  };
};
